import { AssembleTruncatedTypography } from "src/components/AssembleTruncatedTypography";

export function DefaultCell() {
  return (
    <AssembleTruncatedTypography align="right">-</AssembleTruncatedTypography>
  );
}
